import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp, Check } from 'lucide-react';

const CustomDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  renderOption,
  renderSelected,
  className = '',
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  return (
    <div className={`relative w-full ${className}`} ref={dropdownRef}>
      {/* Trigger Button */}
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`
          w-full px-4 py-2.5 rounded-lg border-2 transition-all duration-200 text-sm
          flex items-center justify-between
          ${isOpen ? 'border-purple-500' : 'border-gray-300'}
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white hover:border-purple-400'}
          focus:outline-none
        `}
      >
        <span className={selectedOption ? 'text-gray-900' : 'text-gray-400'}>
          {renderSelected && selectedOption
            ? renderSelected(selectedOption)
            : selectedOption?.label || placeholder}
        </span>
        {isOpen ? (
          <ChevronUp className="w-4 h-4 text-gray-500" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-500" />
        )}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute z-50 w-full mt-2 bg-white border-2 border-purple-500 rounded-lg shadow-lg max-h-64 overflow-y-auto">
          {options.map((option) => {
            const isSelected = option.value === value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => handleSelect(option)}
                className={`
                  w-full px-4 py-2.5 text-left flex items-center justify-between text-sm
                  transition-colors duration-150
                  ${isSelected ? 'bg-purple-50 text-purple-600' : 'text-gray-700 hover:bg-gray-50'}
                `}
              >
                {renderOption ? renderOption(option) : (
                  <span className={isSelected ? 'font-medium' : ''}>
                    {option.label}
                  </span>
                )}
                {isSelected && (
                  <Check className="w-4 h-4 text-purple-600" />
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
